<div class="component-container">
    <div #formioFormParent *ngIf="formioFormVisible" class="card p-3 mip-noborder">
        <formio #formioForm
                [form]="formJson"
                [submission]="formDataJson"
                [readOnly]="readOnlyForm"
                [refresh]="refreshForm"
                [options]="formOptions"
                (change)="onChange($event)">
        </formio>
        <div *ngIf="showUpdateClinicianDataButton || showCancelButton"
             class="card bg-light p-3 justify-content-end flex-row">
            <p-button *ngIf="showUpdateClinicianDataButton" label="Update Clinician Data" severity="primary"
                      (onClick)="updateClinicianData()"></p-button>
            <p-button *ngIf="showCancelButton" class="ml-2" label="Cancel" severity="primary"
                      (onClick)="onCancel()"></p-button>
        </div>
    </div>
    <div *ngIf="invalidParameters" class="text-info card bg-light p-3">
        <h3>Invalid parameters.</h3>
    </div>
    <div *ngIf="dataFilledAlready" class="text-info card bg-light p-3">
        <h3>This form has already been filled.</h3>
    </div>
    <div *ngIf="readOnlyForm" class="card bg-light p-3 justify-content-end flex-row">
        <p-button *ngIf="showBackButton" class="mr-2" label="Back" severity="primary" (onClick)="navigateBack()"></p-button>
        <p-button [label]="generatePdfButtonLabel" severity="primary" (onClick)="generatePDF()"
                  [loading]="generatingPdf"></p-button>
    </div>
    <div>
        <p-dialog [(visible)]="showImageUploadDialog" header="Form Image Uploader" [modal]="true" [closable]="true"
                  [responsive]="true" (onHide)="discardImageUploaded(false)">
            <bb-image-uploader (uploadHandler)="imageUploading($event)" [maxSizePx]="maxSizePx">
            </bb-image-uploader>
        </p-dialog>
    </div>
</div>

<formio-share-dialog header="Share PDF" />